import { observer } from 'mobx-react-lite';

function PaginationExtraLabel({ currentResults, total }: { currentResults: number; total: number}) {
  return (
    <p>
      Mostrando
      {' '}
      <strong>
        {currentResults}
        {' '}
      </strong>
      de
      {' '}
      <strong>{total}</strong>
      {' '}
      resultados
    </p>
  );
}

export default observer(PaginationExtraLabel);
